import AdminClinicsPage from "pages/admin_clinics";
import AdminClinicEditPage from "pages/admin_clinics/clinic_edit";
import HelpsList from "pages/admin_help";
import HelpForm from "pages/admin_help/help-form";
import AdminPatientEditPage from "pages/admin_patient_edit";
import AdminPatientsPage from "pages/admin_patients";
import ArticlesList from "pages/articles";
import ArticleForm from "pages/articles/article-form";
import GraphComponent from "pages/graph";
import NoticesList from "pages/notices";
import NoticeForm from "pages/notices/notice-form";
import SettingPassword from "pages/settings/password";
import SettingThreshold from "pages/settings/threshold";
import AdminSettingDevicePage from "pages/admin_setting_device";
import AdminSettingCertificatePage from "pages/admin_setting_certificate";
import { ROUTE } from "./route";

const adminRoutes = [
  {
    path: ROUTE.ADMIN.PATIENTS,
    component: AdminPatientsPage,
  },
  {
    path: ROUTE.ADMIN.PATIENTS_EDIT,
    component: AdminPatientEditPage,
  },
  {
    path: ROUTE.ADMIN.CLINIC,
    component: AdminClinicsPage,
  },
  {
    path: ROUTE.ADMIN.CLINIC_EDIT,
    component: AdminClinicEditPage,
  },
  {
    path: ROUTE.ADMIN.ARTICLES,
    component: ArticlesList,
  },
  {
    path: ROUTE.ADMIN.ARTICLES_CREATE,
    component: ArticleForm,
  },
  {
    path: ROUTE.ADMIN.ARTICLES_EDIT,
    component: ArticleForm,
  },
  {
    path: ROUTE.ADMIN.HELP,
    component: HelpsList,
  },
  {
    path: ROUTE.ADMIN.HELP_CREATE,
    component: HelpForm,
  },
  {
    path: ROUTE.ADMIN.HELP_EDIT,
    component: HelpForm,
  },
  {
    path: ROUTE.ADMIN.NOTICES,
    component: NoticesList,
  },
  {
    path: ROUTE.ADMIN.NOTICES_CREATE,
    component: NoticeForm,
  },
  {
    path: ROUTE.ADMIN.NOTICES_EDIT,
    component: NoticeForm,
  },
  {
    path: ROUTE.ADMIN.SETTING_THRESHOLD,
    component: SettingThreshold,
  },
  {
    path: ROUTE.ADMIN.SETTING_PASSWORD,
    component: SettingPassword,
  },
  {
    path: ROUTE.ADMIN.SETTING_DEVICE,
    component: AdminSettingDevicePage,
  },
  {
    path: ROUTE.ADMIN.SETTING_CERTIFICATE,
    component: AdminSettingCertificatePage,
  },
  {
    path: ROUTE.ADMIN.GRAPH,
    component: GraphComponent,
  },
];

export default adminRoutes;
